import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import SEO from "../components/SEO/Seo"

export const Head = ({ data }) => {
  const { seo } = data.wpPage

  return (
    <SEO
      title={seo?.metaTitle}
      description={seo?.metaDescription}
      keywords={seo?.keywords}
    />
  )
}

export default function TermsOfUse({ data }) {
  const { content } = data.wpPage

  return (
    <Layout>
      <section className="bg-dorot-purple py-18">
        <h1 className="font-gelica text-_6048 font-semibold text-center text-white">
          Terms of Use
        </h1>
      </section>
      <section className="bg-accent-purple">
        <div
          id="pageContent"
          className="px-7.5 py-7 md:px-13 md:py-10 lg:px-18 lg:py-13.5 text-dorot-purple [&>p]:text-_2032 [&>p]:font-goldplay [&>p]:font-semibold [&>p]:mb-11 [&>h4]:text-_2432 [&>h4]:font-gelica [&>h4]:font-bold [&>h4]:mb-5 [&>h4]:scroll-mt-36 [&>ul]:pl-10 [&>ul]:mb-11"
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>
      </section>
    </Layout>
  )
}

export const data = graphql`
  query {
    wpPage(slug: { eq: "terms-of-use" }) {
      content
      slug
      title
      seo {
        keywords
        metaDescription
        metaTitle
      }
    }
  }
`
